module.exports = __webpack_public_path__ + "img/sales-figures.a5dc8c06.svg";